/*
#*===================================================================
#*
#* Licensed Materials - Property of Zuum Transportation Inc.
#*
#* Copyright Zuum 2015-2021. All Rights Reserved.
#*
#*===================================================================
*/

import { LocalStorageAbstractService } from '@truckstop-tms/zuum-lib';
import { BaseStorageKeys, PREFIXES } from '../base-storage.service';
export const LOCAL_STORAGE_TOKEN = 'LocalStorageService';
/**
 * Local storage service for sharing data between the project and zuum-lib
 */
export class LocalStorageService implements LocalStorageAbstractService {
  private clientSettings: any;

  getClientSettings(): any {
    return this.clientSettings;
  }

  setClientSettings(clientSettings: any): void {
    this.clientSettings = clientSettings;
    localStorage.setItem(`${PREFIXES.SUPER_ADMIN}_${BaseStorageKeys.ClientConfig}`, JSON.stringify(clientSettings));
  }
}
